import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export const useOpsAuditLog = (filters?: { tableName?: string }) => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ["ops_audit_log", filters, user?.id],
    queryFn: async () => {
      let q = supabase
        .from("ops_audit_log")
        .select("*")
        .order("changed_at", { ascending: false })
        .limit(200);

      if (filters?.tableName) q = q.eq("table_name", filters.tableName);

      const { data, error } = await q;
      if (error) throw error;
      return data ?? [];
    },
    enabled: !!user,
  });
};
